import { Detail } from '../containers';

export default function DetailPage() {
  return <Detail />;
}
